import { useState } from "react";
import { useAppContext } from "../../../../../AppContext";
import { useApiMutation } from "../../../../../common/infrastructure/hooks/useApiMutation";
import { IUserWizardFormModel } from "../../../../administration/usersAdministration/userWizard/models/userWizardFormModel";
import { SubmitHandler } from "react-hook-form";
import { dateUtility } from "../../../../../common/infrastructure/utilities/dateUtility";
import { normalizePhone } from "../../../../../common/components/forms/inputs/phoneField/utils/PhoneInputUtility";
import { endpointsMetadata } from "../../../../../common/infrastructure/routes/endpointsMetadata";

export const useFamilyMembers = (familyId: number) => {
  const { isDesktopOrTablet } = useAppContext();
  const [showNewUserDialog, setShowNewUserDialog] = useState(false);
  const [isCreateRequestLoading, setIsCreateRequestLoading] = useState(false);
  const { mutateAsync } = useApiMutation();
  const width = isDesktopOrTablet ? "600px" : "80%";

  const handleSubmit: SubmitHandler<IUserWizardFormModel> = async (data) => {
    setIsCreateRequestLoading(true);
   
    if (data.phoneNumber) {
      data.phoneNumber = normalizePhone(data.phoneNumber);
    }

    data.familyId = familyId;

    try {
      await mutateAsync(
        {
          endpoint: endpointsMetadata.myFamily.createUser,
          globalIsLoading: false,
          method: "post",
          invalidateKeys: [
            [endpointsMetadata.myFamily.wizardGetFamilyData],
            [endpointsMetadata.myFamily.getCurrentUserFamily],
          ],
          ...data,
        },
        {
          onSuccess: () => {
            setShowNewUserDialog(false);
          },
        }
      );
    } catch {
    } finally {
      setIsCreateRequestLoading(false);
    }
  };

  return {
    showNewUserDialog,
    isCreateRequestLoading,
    width,
    setShowNewUserDialog,
    handleSubmit,
  };
};
